$(function(){
  // Date picker for sermon edit page
  $("input.date-picker")
    .kendoDatePicker({ format: "yyyy/MM/dd" })
    .attr('readonly','readonly');

  // Date picker for sermon form
  var $sermonDate = $("#sermon_preached_at");
  var sds = $sermonDate.attr('value');
  var sdv = (sds) ? new Date(sds) : new Date();
  $sermonDate
    .attr('value', sdv.getUTCFullYear()+'/'+(sdv.getUTCMonth()+1)+'/'+sdv.getUTCDate());
});